import { Popover, Typography } from 'antd';
import React, { FC, useCallback, useState } from 'react';
import { Avatar } from 'components/atoms/avatar';
import { ProfileMenu } from 'components/molecules/profile-menu';
import { useUser } from 'hooks/use-user';
import { fullName } from 'utils/full-name';
import styles from './profile.module.css';

export const Profile: FC = () => {
  const { user } = useUser();

  const [visible, setVisible] = useState<boolean>(false);

  const hide = useCallback(() => {
    setVisible(false);
  }, []);

  const handleVisibleChange = useCallback((newVisible) => {
    setVisible(newVisible);
  }, []);

  return (
    <Popover
      overlayClassName={styles.popover}
      placement="rightTop"
      content={<ProfileMenu user={user} hide={hide} />}
      visible={visible}
      onVisibleChange={handleVisibleChange}
    >
      <Typography.Link>
        <Avatar src={user.photoUrl} name={fullName(user)} />
      </Typography.Link>
    </Popover>
  );
};
